import { ROUTE_NAME } from '@constants';
const facility = {
  path: '/facility',
  redirect: '/facility/clubhouse',
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '시설안내',
    navMenu: true,
    description: '송추컨트리클럽의 시설을 안내해드립니다.',
  },
  children: [
    {
      name: ROUTE_NAME.ClubHouse,
      path: 'clubhouse',
      component: () => import('@views/facility/ClubHouse.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '클럽하우스',
      },
    },
    {
      name: ROUTE_NAME.EventHall,
      path: 'event-hall',
      component: () => import('@views/facility/EventHall.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '레스토랑&그늘집',
      },
    },
    // {
    //   name: ROUTE_NAME.HalfwayHouse,
    //   path: 'halfway-house',
    //   component: () => import('@views/facility/HalfwayHouse.vue'),
    //   meta: {
    //     breadcrumb: true,
    //     breadcrumbName: '그늘집',
    //   },
    // },
    // {
    //   name: ROUTE_NAME.DiningInfo,
    //   path: 'dining-info',
    //   component: () => import('@views/facility/DiningInfo.vue'),
    //   meta: {
    //     breadcrumb: true,
    //     breadcrumbName: '식음료소개',
    //   },
    // },
    {
      name: ROUTE_NAME.LockerRoom,
      path: 'locker-room',
      component: () => import('@views/facility/LockerRoom.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '락커룸',
      },
    },
    {
      name: ROUTE_NAME.ProShop,
      path: 'pro-shop',
      component: () => import('@views/facility/ProShop.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '프로샵',
      },
    },
  ],
};
export default facility;
